/**
 * OrderDetail
 */
import { mapState, mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import countdown from 'countdown';

import SharedHeader from '@/components/SharedHeader.vue';
import SharedFooter from '@/components/SharedFooter.vue';
import WayFindBar from '@/components/WayFindBar.vue';
import Footer from '@/components/Footer.vue';
import Aside from '@/components/Aside.vue';
import Spinner from '@/components/Spinner.vue';

import { OrderMixin } from '@/scripts/Mall/Order/Order.mixin';

import { LOADING_MESSAGE } from './OrderDetail.constants';
import { OrderDetailMixin } from './OrderDetail.mixin';

const OrderAgreementMixin = {
  name: 'OrderAgreementMixin',

  data: () => {
    return {
      isShowAgreement: false,
    };
  },

  computed: {
    ...mapState('Agreement', {
      ms_res_getAgreement: 'res_getAgreement',
    }),
  },

  methods: {
    ...mapActions('Agreement', {
      ma_getOrderAgreement: 'getOrderAgreement',
    }),

    async getOrderAgreement() {
      await this.ma_getOrderAgreement({
        orderId: this.$route.params.id,
      });
      this.isShowAgreement = !_.isEmpty(this.ms_res_getAgreement);
    },

    gotoAgreement() {
      const urlAgreement = `https://msite.pzacademy.com/agreement/order/${this.$route.params.courseId}`;
      window.open(urlAgreement, '_blank');
    },
  },

  created() {
    this.getOrderAgreement();
  },
};

export default {
  name: 'OrderDetail',

  mixins: [OrderMixin, OrderDetailMixin, OrderAgreementMixin],

  components: {
    SharedHeader,
    SharedFooter,
    WayFindBar,
    Footer,
    Aside,
    Spinner,
  },

  data: () => {
    return {
      timeNow: null,
      order: {
        objStrCreatedDate: {},
      },
      loadingMessage: LOADING_MESSAGE,
    };
  },

  computed: {
    ...mapState({
      ms_isDebug: 'isDebug',
    }),

    ...mapState('Mall/OrderDetail', {
      ms_isRequest: 'isRequest',
    }),

    ...mapGetters('Mall/OrderDetail', {
      mg_MyOrderDetail: 'MyOrderDetail',
    }),

    c_objStrDueStartTime() {
      return this.order.objStrDueStartTime ? this.order.objStrDueStartTime : {};
    },

    c_objStrDueEndTime() {
      return this.order.objStrDueEndTime ? this.order.objStrDueEndTime : {};
    },
  },

  methods: {
    ...mapActions('Mall/OrderDetail', {
      ma_getMarketTradeDetail: 'getMarketTradeDetail',
    }),

    makeMyOrderDetail() {
      this.order = {
        ...this.order,
        ...this.mg_MyOrderDetail,
        objStrCreatedDate: this.getObjStrDueTime(this.mg_MyOrderDetail.createdDate),
        i_orderDueStatus: '',
        i_myOrderId: this.$route.params.id,
        i_realPrice: undefined !== this.mg_MyOrderDetail.realPrice
          ? this.mg_MyOrderDetail.realPrice
          : this.mg_MyOrderDetail.goodsPrice,
        name: this.makeCpaGoodsDetailName(this.mg_MyOrderDetail.name),
      };

      if (1 === this.order.tradeStatus) {
        this.order = {
          ...this.order,
          i_orderDueStatus: 'isFinished',
          objStrPayDate: this.getObjStrDueTime(this.mg_MyOrderDetail.payDate),
        };
      } else if (-1 === this.order.tradeStatus) {
        this.order = {
          ...this.order,
          i_orderDueStatus: 'isOverDueEndTime',
        };
      } else if (0 === this.order.tradeStatus) {
        const isPresellBalance =
          this.order.isPresellTrade &&
          0 === this.order.preSellType &&
          1 === this.order.preSellStatus;
        const isNotStarted =
          isPresellBalance && this.order.dueStartTime && this.timeNow < this.order.dueStartTime;
        this.order = {
          ...this.order,
          i_orderDueStatus: isNotStarted ? 'isNotStarted' : 'isOverDueStartTime',
        };
        if (this.order.dueStartTime) {
          this.order = {
            ...this.order,
            dueStartTimeSpan: null,
            dueStartTimeCountdownId: countdown(
              (timeSpan) => {
                this.order.dueStartTimeSpan = timeSpan;
              },
              this.order.dueStartTime,
              countdown.DAYS | countdown.HOURS | countdown.MINUTES | countdown.SECONDS
            ),
            objStrDueStartTime: this.getObjStrDueTime(this.order.dueStartTime),
          };
        }
        if (this.order.dueEndTime) {
          this.order = {
            ...this.order,
            dueEndTimeSpan: null,
            dueEndTimeCountdownId: countdown(
              (timeSpan) => {
                this.order.dueEndTimeSpan = timeSpan;
              },
              this.order.dueEndTime,
              countdown.DAYS | countdown.HOURS | countdown.MINUTES | countdown.SECONDS
            ),
            objStrDueEndTime: this.getObjStrDueTime(this.order.dueEndTime),
          };
        } /* else if (this.order.dueEndTime && this.order.dueEndTime < this.timeNow) {
          this.order = {
            ...this.order,
            i_orderDueStatus: 'isOverDueEndTime',
          };
        } */
      }
    },

    copyDeliveryCode() {
      this.$refs.inputDeliveryCode.select();
      document.execCommand('Copy');
    },

    async _OrderDetailCreated() {
      await this.ma_getMarketTradeDetail({
        type: this.$route.params.type,
        id: this.$route.params.id,
      });
      this.timeNow = new Date().getTime();
      this.makeMyOrderDetail();
    },
  },

  created() {
    this._OrderDetailCreated();
  },

  beforeDestroy() {
    clearInterval(this.order.dueStartTimeCountdownId);
    clearInterval(this.order.dueEndTimeCountdownId);
  },
};
